export let scale = 1;
export let objCurrent = null;
export let objPrevious = null;
export const arTargets = [];

export const updateScale = (updatedScale) => {
  scale = updatedScale;
};

export const setObjCurrent = (object) => {
  objCurrent = object;
};

export const start = (objEvent, target) => {
  objCurrent = target;

  objCurrent.lastX = objEvent.clientX / scale;
  objCurrent.lastY = objEvent.clientY / scale;
  objCurrent.lastRotation = 0;
  objCurrent.isAnimated = false;
  objCurrent.style.zIndex = "99";
  objCurrent.setAttribute("aria-grabbed", "true");

  return false;
};

export const unscaledStart = (objEvent, target) => {
  objCurrent = target;

  objCurrent.lastX = objEvent.clientX;
  objCurrent.lastY = objEvent.clientY;
  objCurrent.lastRotation = 0;
  objCurrent.isAnimated = false;
  objCurrent.style.zIndex = "99";
  objCurrent.setAttribute("aria-grabbed", "true");

  return false;
};

export const end = () => {
  // Set the current active element to null
  if (objCurrent != null) {
    objCurrent.style.zIndex = "2";
    objCurrent.setAttribute("aria-grabbed", "false");
    if (objPrevious !== null && objPrevious !== objCurrent) {
      objPrevious.style.zIndex = "1";
    }
    objPrevious = objCurrent;
  }
  objCurrent = null;

  return false;
};

export const getTransform = (elem) => {
  const matrix = getComputedStyle(elem, null).transform;

  const regex = /-?\d*\.{0,1}\d+/g;
  const values = matrix.match(regex);

  let translateX = "";
  let translateY = "";

  if (values != null) {
    translateX = values[4];
    translateY = values[5];
  }

  return {
    translateX: translateX,
    translateY: translateY,
  };
};

export const drag = (objEvent) => {
  if (objCurrent != null) {
    // Calculate new position
    const iCurrentY = objEvent.clientY / scale;
    const iCurrentX = objEvent.clientX / scale;

    const transform = getTransform(objCurrent);

    const iYPos = parseFloat(transform.translateY);
    const iXPos = parseFloat(transform.translateX);

    const iNewX = iXPos + iCurrentX - objCurrent.lastX;
    const iNewY = iYPos + iCurrentY - objCurrent.lastY;

    const velocity = (iCurrentX - objCurrent.lastX) * 3;
    const rotation = parseInt((velocity * 100) / 360, 10);
    let rotate = 0;

    if (velocity !== 0) {
      rotate = rotation;
    } else {
      rotate = objCurrent.lastRotation;
    }

    objCurrent.style.transform =
      "translate3d(" +
      iNewX +
      "px, " +
      iNewY +
      "px, 0px) rotateZ(" +
      rotate +
      "deg) ";

    objCurrent.lastX = iCurrentX;
    objCurrent.lastY = iCurrentY;
    objCurrent.lastRotation = rotation;
    objCurrent.isAnimated = false;
  }
  return false;
};

export const unscaledDrag = (objEvent) => {
  if (objCurrent != null) {
    // Calculate new position
    const iCurrentY = objEvent.clientY;
    const iCurrentX = objEvent.clientX;

    const transform = getTransform(objCurrent);

    const iYPos = parseFloat(transform.translateY);
    const iXPos = parseFloat(transform.translateX);

    const iNewX = iXPos + iCurrentX - objCurrent.lastX;
    const iNewY = iYPos + iCurrentY - objCurrent.lastY;

    const velocity = (iCurrentX - objCurrent.lastX) * 3;
    const rotation = parseInt((velocity * 100) / 360, 10);
    let rotate = 0;

    if (velocity !== 0) {
      rotate = rotation;
    } else {
      rotate = objCurrent.lastRotation;
    }

    objCurrent.style.transform =
      "translate3d(" +
      iNewX +
      "px, " +
      iNewY +
      "px, 0px) rotateZ(" +
      rotate +
      "deg) ";

    objCurrent.lastX = iCurrentX;
    objCurrent.lastY = iCurrentY;
    objCurrent.lastRotation = rotation;
    objCurrent.isAnimated = false;
  }
  return false;
};

export const teleport = (objCurrent, targetData) => {
  //targetData = {left, top, elem}
  if (objCurrent != null) {
    const objPos = objCurrent.parentNode.getBoundingClientRect();

    const finalX =
      targetData.left / scale -
      objPos.left / scale +
      targetData.width / 2 -
      objPos.width / 2;
    // + (targetData.width / 2) - (objCurrent.innerWidth / 2)
    const finalY =
      targetData.bottom / scale - objPos.bottom / scale - 25 / scale;
    // + targetData.height - objPos.height

    objCurrent.style.transform =
      "translate3d(" + finalX + "px, " + finalY + "px, 0px) rotateZ(0deg) ";
  }
  return false;
};

export const getTarget = (current, targetList) => {
  let iCurrentXCenter, iCurrentYCenter;

  if (current != null) {
    //var strExisting = current.parentNode.getAttribute('id');
    let offset = calculatePosition(current);

    if (
      current.id === "P2_1" ||
      current.id === "P20_2" ||
      current.id === "P200_3" ||
      current.id === "P1000_4"
    ) {
      iCurrentXCenter =
        offset.left / scale + current.parentNode.offsetWidth / 2;
      iCurrentYCenter =
        offset.top / scale + current.parentNode.offsetHeight / 2 + 100;
    } else {
      iCurrentXCenter =
        offset.left / scale + current.parentNode.offsetWidth / 2;
      iCurrentYCenter =
        offset.top / scale + current.parentNode.offsetHeight / 2;
    }

    let iLeft, iRight, iTop, iBottom, iCounter;

    // console.log(current.id, iCurrentXCenter, iCurrentYCenter);
    //
    // var tNode = document.createElement('div');
    // document.getElementById('dragdrop').appendChild(tNode);
    //
    // tNode.className = current.id;
    // tNode.style.position = 'absolute';
    // tNode.style.left = iCurrentXCenter+'px';
    // tNode.style.top = iCurrentYCenter+'px';
    // tNode.style.width = 2+'px';
    // tNode.style.height = 2+'px';
    // tNode.style.border = '3px solid green';

    for (iCounter = 0; iCounter < targetList.length; iCounter++) {
      if (current.id !== targetList[iCounter].id) {
        offset = calculatePosition(targetList[iCounter]);

        iLeft = offset.left / scale;
        iRight = iLeft + targetList[iCounter].offsetWidth;
        iTop = offset.top / scale;
        iBottom = iTop + targetList[iCounter].offsetHeight;

        // var node = document.createElement('div');
        // document.getElementById('dragdrop').appendChild(node);
        //
        // node.className = targetList[iCounter].id;
        // node.style.position = 'absolute';
        // node.style.left = iLeft+'px';
        // node.style.top = iTop+'px';
        // node.style.width = (iRight - iLeft)+'px';
        // node.style.height = (iBottom - iTop)+'px';
        // node.style.border = '3px solid red';
        //
        //
        // console.log("Pipette: x: ", iCurrentXCenter," y: ",iCurrentYCenter);
        // console.log("target: ",iLeft," ",iRight," ",iBottom," ",iTop);

        // Determine if current object is over the target
        if (
          iCurrentXCenter > iLeft &&
          iCurrentXCenter < iRight &&
          iCurrentYCenter > iTop &&
          iCurrentYCenter < iBottom
        ) {
          //node.style.border = '3px solid green';
          return targetList[iCounter];
        }
      }
    }
  }
  // Current object is not over a target
  return "";
};

export const getUnscaledTarget = (current, targetList) => {
  if (current != null) {
    //var strExisting = current.parentNode.getAttribute('id');
    let offset = calculatePosition(current);

    const iCurrentXCenter = offset.left + current.offsetWidth / 2;
    const iCurrentYCenter = offset.top + current.offsetHeight / 2;

    let iLeft, iRight, iTop, iBottom, iCounter;

    for (iCounter = 0; iCounter < targetList.length; iCounter++) {
      if (current.id !== targetList[iCounter].id) {
        offset = calculatePosition(targetList[iCounter]);

        iLeft = offset.left;
        iRight = iLeft + targetList[iCounter].offsetWidth;
        iTop = offset.top;
        iBottom = iTop + targetList[iCounter].offsetHeight;

        // Determine if current object is over the target
        if (
          iCurrentXCenter > iLeft &&
          iCurrentXCenter < iRight &&
          iCurrentYCenter > iTop &&
          iCurrentYCenter < iBottom
        ) {
          //node.style.border = '3px solid green';
          return targetList[iCounter];
        }
      }
    }
  }
  // Current object is not over a target
  return "";
};

export const calculatePosition = (objElement) => {
  const objPos = objElement.getBoundingClientRect();

  return objPos;
};

export const moveCalcPos = (elem) => {
  const offset = { left: 0, top: 0 };
  if (elem.offsetParent) {
    do {
      offset.left += parseFloat(elem.offsetLeft);
      offset.top += parseFloat(elem.offsetTop);
      elem = elem.offsetParent;
    } while (elem.offsetParent);
  }
  return offset;
};
